import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export function useEmailMessageBody(bodyUrl: string | null | undefined) {
  return useQuery<string>({
    enabled: Boolean(bodyUrl),
    queryKey: ['email-message-body', bodyUrl],
    staleTime: Infinity,
    queryFn: async () => {
      const response = await fetch(bodyUrl!);
      if (!response.ok) {
        throw new Error('Failed to fetch email message body');
      }
      return response.text();
    }
  });
}

/**
 * The short-lived URLs of a message's inline images, keyed by file id. They
 * expire after 15 minutes, so a query older than 10 minutes fetches new ones.
 */
export function useEmailMessageContentMedia(contentMediaUrl: string | null | undefined): {
  urls: Record<string, string>;
  isError: boolean;
} {
  const query = useQuery<Diagonal.Notifications.Data.EmailMessageContentMediaData>({
    enabled: Boolean(contentMediaUrl),
    queryKey: ['email-message-content-media', contentMediaUrl],
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      if (!contentMediaUrl) {
        throw new Error('No content-media URL');
      }
      const response = await axios.get(contentMediaUrl);
      return response.data;
    }
  });

  return { urls: query.data?.urls ?? {}, isError: query.isError };
}
